import { backendApi } from '@app/services'

import { FetchCountriesResponse } from './types'

export const fetchCountries = async (lang: string) => {
  const { data } = await backendApi.get<FetchCountriesResponse[]>(
    `/countries/${lang}`
  )
  return data
}
